module.exports = __webpack_public_path__ + "img/content-img5_2.67b38f02.png";